// extracted by mini-css-extract-plugin
export var localeSelector = "_40-0";